<template>
  <div class="nd-follow">
    <div class="title">关注天美贷公众号，获取更多福利信息</div>
    <div class="copy-container">
      <img src="./icon_weixin.png" >
      <b>微信搜索  ct_tmd</b>
      <span @click="copy">复制</span>
    </div>
  </div>
</template>
<script>
import { copyToClipbord } from '@/assets/utils'

export default {
  methods: {
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    }
  }
}

</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.nd-follow {
  width: 670px;
  height: 195px;
  background: #FFFFFF;
  border-radius: 20px;
  padding: 30px 40px;
  .title {
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
  }
  .copy-container {
    width: 590px;
    height: 84px;
    background: #F7F7F7;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 18px;
    padding: 23px;
    img {
      width:36px;
      height:36px;
    }
    b{
      padding-left: 15px;
      flex:1;
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    span {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #8EB2D8;
    }
  }
}
</style>